import { boolean, json, number, string } from '@/config/helpers'
import { registerDevTool } from '@/devtools'

const RUNTIME_ENV = string(globalThis.import_meta_env.RUNTIME_ENV)

/**
 * Note!
 * Don't try to access import.meta.env object.
 * It is not replaced by "import-meta-env-loader" loader.
 * Only globalThis.import_meta_env.KEY is being replaced.
 */
export const AppConfig = {
  RUNTIME_ENV,
  GATEWAY_URL: string(globalThis.import_meta_env.GATEWAY_URL, { required: RUNTIME_ENV !== 'proxied' }),
  GATEWAY_ACCOUNT_URL: string(globalThis.import_meta_env.GATEWAY_ACCOUNT_URL),
  GATEWAY_AUDIT_URL: string(globalThis.import_meta_env.GATEWAY_AUDIT_URL),
  GATEWAY_CLIENT_REQUESTS_URL: string(globalThis.import_meta_env.GATEWAY_CLIENT_REQUESTS_URL),
  GATEWAY_DOCUMENT_STORAGE2_URL: string(globalThis.import_meta_env.GATEWAY_DOCUMENT_STORAGE2_URL),
  GATEWAY_OPEN_BANKING_URL: string(globalThis.import_meta_env.GATEWAY_OPEN_BANKING_URL),
  GATEWAY_SEPA_URL: string(globalThis.import_meta_env.GATEWAY_SEPA_URL),
  GATEWAY_WATCHDOG_URL: string(globalThis.import_meta_env.GATEWAY_WATCHDOG_URL),
  GATEWAY_PORTAL_URL: string(globalThis.import_meta_env.GATEWAY_PORTAL_URL),
  GOOGLE_LOGIN_TOKEN: string(globalThis.import_meta_env.GOOGLE_LOGIN_TOKEN),
  GOOGLE_HOSTED_DOMAIN: string(globalThis.import_meta_env.GOOGLE_HOSTED_DOMAIN),
  LOGIN_BY_USERNAME: boolean(globalThis.import_meta_env.LOGIN_BY_USERNAME),
  DISABLE_ACCEPT_BUTTON_FOR_ACCOUNTS: json(globalThis.import_meta_env.DISABLE_ACCEPT_BUTTON_FOR_ACCOUNTS),
  STALE_CARD_ORDERS_AFTER_DAYS: number(globalThis.import_meta_env.STALE_CARD_ORDERS_AFTER_DAYS),
  REPORTS_URL: string(globalThis.import_meta_env.REPORTS_URL),
  SWIFT_TRACKER_URL: string(globalThis.import_meta_env.SWIFT_TRACKER_URL),
  SALESFORCE_URL: string(globalThis.import_meta_env.SALESFORCE_URL),
  STORAGE_SERVICE_URL: string(globalThis.import_meta_env.STORAGE_SERVICE_URL),
  YAPILY_HOSTED_PAGES_COUNTRIES: json(globalThis.import_meta_env.YAPILY_HOSTED_PAGES_COUNTRIES),
  PORTAL_FRONT_URL: string(globalThis.import_meta_env.PORTAL_FRONT_URL),
  PORTAL_SIGN_UP_URL: string(globalThis.import_meta_env.PORTAL_SIGN_UP_URL),
  AUTOLOGIN_URL: string(globalThis.import_meta_env.AUTOLOGIN_URL),
  AUTOLOGIN_ENABLED: boolean(globalThis.import_meta_env.AUTOLOGIN_ENABLED)
}

registerDevTool('showAppConfig', () => {
  console.log(AppConfig)
})
